
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function formatISODate(ISO) {
    if (ISO && (ISO !== '') && (ISO !== '0001-01-01T00:00:00Z')) {
        const date = new Date(ISO);
        return months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
    }
    return "";
}